import React from "react";

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  visibleStepNumber?: number;
  totalVisibleSteps?: number;
  stepName?: string;
  stepNavigation: any;
  isAuthenticated: boolean;
  specialStep: boolean;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  currentStep,
  totalSteps,
  visibleStepNumber,
  totalVisibleSteps,
  stepName,
  stepNavigation,
  isAuthenticated,
  specialStep,
}) => {
  // Use visible step numbers if provided, otherwise fall back to regular step numbers
  const displayCurrentStep =
    visibleStepNumber !== undefined ? visibleStepNumber : currentStep;
  const displayTotalSteps =
    totalVisibleSteps !== undefined ? totalVisibleSteps : totalSteps;

  // Calculate progress percentage based on visible steps
  const progressPercentage =
    displayTotalSteps > 0 ? (displayCurrentStep / displayTotalSteps) * 100 : 0;

  // Generate step indicators
  const generateStepIndicators = () => {
    const indicators = [];
    for (let i = 1; i <= displayTotalSteps; i++) {
      const isActive = i === displayCurrentStep;
      const isCompleted = i < displayCurrentStep;
      
      // Check if user is on success step - disable all navigation for non-authenticated users
      const noClick = specialStep && 
        !isAuthenticated;

      indicators.push(
        <div
          key={i}
          className={`step-indicator ${isActive ? "active" : ""} ${isCompleted ? "completed" : ""} ${specialStep ? "disabled" : ""}`}
          onClick={async (e) => {
            e.preventDefault();
            // Don't allow navigation if on success step
            if (noClick) {
              return;
            }
            if (e?.currentTarget?.textContent) {
              const num = parseInt(e.currentTarget?.textContent);
              // Convert visible step number back to actual step number
              const actualStepNumber = stepNavigation.isAuthenticated ? num : num + 1;
              stepNavigation.goToStep(actualStepNumber);
            }
          }}
        >
          <div className="step-number">{i}</div>
        </div>,
      );
    }
    return indicators;
  };

  return (
    <div className="progress-container">
      {/* Progress Bar */}
      <div className="progress-bar-container mb-4">
        <div
          className="progress-bar"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>

      {/* Step Indicators */}
      <div className="step-indicators-container mb-6">
        <div className="flex justify-center space-x-2">
          {generateStepIndicators()}
        </div>
      </div>

      {/* Step Information */}
      <div className="text-center mb-6">
        {stepName && (
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            {stepName
              .replace("AboutMe", "What I do")
              .replace(/([a-z])([A-Z])/g, "$1 $2")
              .replace("Customization", "Add Branding")}
          </h2>
        )}
      </div>
    </div>
  );
};
